import React, { memo } from "react"
import styles from "../../News.module.css"
import moment from 'moment'
import 'moment/locale/ru'
import Sharing from "../../../Rating/Sharing";

const NewsItem = (props) => {
    const name = props.data.name
    const likes = props.data.likes_count
    const sharing = props.data.sharings_count
    const tags = props.data.tags
    const date = moment(props.data.created_at).format('DD MMM YYYY')
    const img = props.data.media.thumb
    return (
        <div className={styles.newsItem}>
            <div className={styles.textContent}>
                <h2 className={styles.title}>
                    {name}
                </h2>
                <div>
                    {tags.map(tag =>
                        <span style={{ marginRight: '11px', color: '#73982C', backgroundColor: '#E2EEDD' }} className="status">{tag.name.ru}</span>
                    )}
                    <div className={styles.newsSharing}>
                    <span className="time">{date}</span>
                        <Sharing type={'news'} likes={likes} sharing={sharing} isLiked={props.data.is_liked} id={props.data.id}/>
                    </div>
                </div>
            </div>
            <div className={styles.imageWrapper}>
                <img alt="Картинка" src={img} />
            </div>
        </div>
    )
}
export default memo(NewsItem)
